import axios from '@/plugins/axios';

class NotificationService {
  /**
   * Získa počet nesplnených úloh pre aktuálneho používateľa
   * @returns {Promise} Promise s počtom nesplnených úloh
   */
  getUnsignedTasksCount() {
    return axios.get('/ulohy/count/nesplnene');
  }

  /**
   * Získa počet neprečítaných novinek pre aktuálneho používateľa
   * @returns {Promise} Promise s počtom neprečítaných novinek
   */
  getUnreadNewsCount() {
    return axios.get('/novinky/count/neprecitane');
  }

  /**
   * Získa počet aktívnych poziadaviek (zadaná + v_rieseni)
   * @returns {Promise} Promise s počtom aktívnych poziadaviek
   */
  getActiveRequestsCount() {
    return axios.get('/poziadavky/count/aktivne');
  }

  /**
   * Získa počet nových podnetov
   * @returns {Promise} Promise s počtom nových podnetov
   */
  getNewFeedbackCount() {
    return axios.get('/feedback/count/nove');
  }

  /**
   * Získa všetky notifikácie (úlohy + novinky + poziadavky + podnety)
   * @returns {Promise} Promise s objektom obsahujúcim počty notifikácií
   */
  async getAllNotifications() {
    try {
      const [tasksResponse, newsResponse, requestsResponse, feedbackResponse] = await Promise.all([
        this.getUnsignedTasksCount(),
        this.getUnreadNewsCount(),
        this.getActiveRequestsCount(),
        this.getNewFeedbackCount()
      ]);

      return {
        tasks: tasksResponse.data.count || 0,
        news: newsResponse.data.count || 0,
        requests: requestsResponse.data.count || 0,
        feedback: feedbackResponse.data.count || 0
      };
    } catch (error) {
      console.error('Chyba pri získavaní notifikácií:', error);
      return {
        tasks: 0,
        news: 0,
        requests: 0,
        feedback: 0
      };
    }
  }
}

export default new NotificationService();
